import React, { useState } from 'react';
import './ListaSolicitudes.css';

const ListaSolicitudes = ({ user, solicitudes, onClose }) => {
  const [filtro, setFiltro] = useState('todas');
  
  const solicitudesFiltradas = solicitudes.filter(sol => {
    if (filtro === 'todas') return true;
    if (filtro === 'altas') return sol.tipo === 'alta';
    if (filtro === 'bajas') return sol.tipo === 'baja';
    if (filtro === 'pendientes') return sol.estado === 'pendiente';
    if (filtro === 'proceso') return sol.estado === 'en_proceso';
    if (filtro === 'completadas') return sol.estado === 'completada';
    return true;
  });

  const getEstadoBadge = (estado) => {
    const badges = {
      'pendiente': { icon: 'clock', color: 'warning', text: 'Pendiente' },
      'en_proceso': { icon: 'spinner', color: 'info', text: 'En Proceso' },
      'completada': { icon: 'check-circle', color: 'success', text: 'Completada' }
    };
    return badges[estado] || badges['pendiente'];
  };

  const formatFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-MX', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatMoneda = (valor) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(valor);
  };

  return (
    <div className="lista-solicitudes-container">
      <div className="lista-header">
        <div>
          <h2>📋 Mis Solicitudes IMSS</h2>
          <p>{solicitudes.length} solicitud{solicitudes.length !== 1 ? 'es' : ''} en total</p>
        </div>
        <button onClick={onClose} className="close-btn">
          <i className="fas fa-times"></i>
        </button>
      </div>

      {/* Filtros */}
      <div className="filtros">
        <button
          className={`filtro-btn ${filtro === 'todas' ? 'active' : ''}`}
          onClick={() => setFiltro('todas')}
        >
          Todas
        </button>
        <button
          className={`filtro-btn ${filtro === 'altas' ? 'active' : ''}`}
          onClick={() => setFiltro('altas')}
        >
          <i className="fas fa-user-plus"></i> Altas
        </button>
        <button
          className={`filtro-btn ${filtro === 'bajas' ? 'active' : ''}`}
          onClick={() => setFiltro('bajas')}
        >
          <i className="fas fa-user-minus"></i> Bajas
        </button>
        <button
          className={`filtro-btn ${filtro === 'pendientes' ? 'active' : ''}`}
          onClick={() => setFiltro('pendientes')}
        >
          <i className="fas fa-clock"></i> Pendientes
        </button>
      </div>

      {/* Lista de solicitudes */}
      <div className="solicitudes-lista">
        {solicitudesFiltradas.length === 0 ? (
          <div className="empty-state">
            <i className="fas fa-inbox"></i>
            <p>No hay solicitudes {filtro !== 'todas' ? `de tipo "${filtro}"` : ''}</p>
          </div>
        ) : (
          solicitudesFiltradas.map((solicitud, index) => {
            const badge = getEstadoBadge(solicitud.estado);
            const datos = solicitud.datos;
            
            return (
              <div key={index} className="solicitud-card">
                <div className="solicitud-card-header">
                  <div className="solicitud-tipo">
                    <i className={`fas fa-user-${solicitud.tipo === 'alta' ? 'plus' : 'minus'}`}></i>
                    <span className="tipo-text">
                      {solicitud.tipo === 'alta' ? 'ALTA' : 'BAJA'} IMSS
                    </span>
                  </div>
                  <span className={`estado-badge ${badge.color}`}>
                    <i className={`fas fa-${badge.icon}`}></i>
                    {badge.text}
                  </span>
                </div>

                <div className="solicitud-card-body">
                  <div className="info-row">
                    <div className="info-item">
                      <span className="info-label">Trabajador:</span>
                      <span className="info-value">{datos.nombreCompleto}</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">NSS:</span>
                      <span className="info-value">{datos.nss}</span>
                    </div>
                  </div>

                  {solicitud.tipo === 'alta' ? (
                    <>
                      <div className="info-row">
                        <div className="info-item">
                          <span className="info-label">RFC:</span>
                          <span className="info-value">{datos.rfc}</span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">Fecha de Alta:</span>
                          <span className="info-value">{formatFecha(datos.fechaAlta)}</span>
                        </div>
                      </div>
                      <div className="info-row">
                        <div className="info-item">
                          <span className="info-label">Salario Diario:</span>
                          <span className="info-value">{formatMoneda(datos.salarioDiario)}</span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">Salario Diario Integrado:</span>
                          <span className="info-value">{formatMoneda(datos.salarioDiarioIntegrado)}</span>
                        </div>
                      </div>
                      {solicitud.archivos && solicitud.archivos.length > 0 && (
                        <div className="info-row">
                          <div className="info-item">
                            <span className="info-label">Documentos adjuntos:</span>
                            <div className="archivos-lista">
                              {solicitud.archivos.map((archivo, idx) => (
                                <span key={idx} className="archivo-item">
                                  <i className="fas fa-file"></i> {archivo}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="info-row">
                        <div className="info-item">
                          <span className="info-label">Fecha de Baja:</span>
                          <span className="info-value">{formatFecha(datos.fechaBaja)}</span>
                        </div>
                        <div className="info-item">
                          <span className="info-label">Tipo de Baja:</span>
                          <span className="info-value">{datos.tipoBaja}</span>
                        </div>
                      </div>
                      <div className="info-row">
                        <div className="info-item full-width">
                          <span className="info-label">Motivo:</span>
                          <span className="info-value">{datos.motivoBaja}</span>
                        </div>
                      </div>
                    </>
                  )}

                  {datos.comentarios && (
                    <div className="info-row">
                      <div className="info-item full-width">
                        <span className="info-label">Comentarios:</span>
                        <span className="info-value">{datos.comentarios}</span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="solicitud-card-footer">
                  <span className="fecha-solicitud">
                    <i className="fas fa-calendar"></i>
                    Solicitado el {formatFecha(solicitud.fecha_solicitud)}
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>

      {solicitudesFiltradas.length > 0 && (
        <div className="lista-footer">
          <p>Mostrando {solicitudesFiltradas.length} de {solicitudes.length} solicitudes</p>
        </div>
      )}
    </div>
  );
};

export default ListaSolicitudes;
